import React, { useState,useEffect } from 'react'

import Badge from '@material-ui/core/Badge'
import { withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import TimerIcon from '@material-ui/icons/Timer'
import { useSnackbar } from 'notistack'
import { green } from '@material-ui/core/colors'


const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -3,
    top: 13,
    border: `2px solid ${theme.palette.background.main}`,
    padding: '0 4px',
  },
}))(Badge)

export default function CountDown({ onClose }) {
  const [count, setcount] = useState(120)
  const { enqueueSnackbar } = useSnackbar()
  

  useEffect(() => {
    const interval = setInterval(() => {
      setcount(count => count-1)
    }, 1000)
    return () =>{clearInterval(interval)}
  }, [])

  useEffect(() => {
    if(count <= 0)
    {
      enqueueSnackbar(`Paiement expiré...`, )
      onClose()
    }
  }, [count])
    
  return (
    <IconButton aria-label="cart">
      <StyledBadge badgeContent={count} max={999} color="secondary">
        <p style={{ fontSize:10, marginRight:5 }}> | Temps paiement restant  </p> <TimerIcon />
      </StyledBadge>
    </IconButton>
  )
}
    